export default __webpack_public_path__ + "images/CQ.e96e02a.png";